export const ar = {
  // Navigation
  profile: "الملف الشخصي",
  salaryBenefits: "الراتب ",
  attendance: "الحضور",
  leaveManagement: " الإجازات",
  employeeSelfServices: "الخدمات الذاتية ",
  calendar: "التقويم",
  settingsLocked: "الإعدادات ",
  escalation: "الشكاوى",
  groups: "المجموعات",
  messages: "الرسائل",

  // Loading
  loadingPermissions: "جاري تحميل الصلاحيات...",

  // Tooltips
  darkModeTooltip: "تبديل إلى الوضع المظلم",
  lightModeTooltip: "تبديل إلى الوضع الفاتح",

  // Common
  loading: "جاري التحميل...",
};

export default ar;
